/**
 * Display labels for a template's category + the tile shape it fits — shared
 * by the catalog cards (`TemplatesPane`) and the detail view
 * (`TemplateDetailPane`) so the two surfaces can never disagree.
 */
import type { DashboardTemplate } from '../../templates/templateTypes';

export const CATEGORY_LABELS: Record<DashboardTemplate['category'], string> = {
  sessions: 'Sessions',
  performance: 'Performance',
  indexes: 'Indexes',
  storage: 'Storage',
  backup: 'Backup',
  jobs: 'Jobs',
};

export const FIT_LABELS: Record<DashboardTemplate['defaultTileType'], string> = {
  chart: 'Chart',
  stat: 'Stat',
  table: 'Table',
  pivot: 'Pivot',
  map: 'Map',
};
